<template>
  <v-select
    v-model="selectedGroup"
    :items="listGroups"
    @change="setSelectedGroup"
    prepend-icon="mdi-list-status"
    item-text="text"
    item-value="value"
    :label="$t('groupBy')"
    dense
    filled
    hide-details
    solo-inverted
  ></v-select>
</template>
<script>
export default {
  name: "components-common-filters-select-casino-group-by",
  data: () => ({
    selectedGroup: {},
  }),

  created() {
    this.reset();
  },

  computed: {
    listGroups() {
      // Opções do Select utilizados para o novo Cassino
      if (this.isNewCasinoPage) {
        return [
          { text: this.$t("games"), value: "game" },
          { text: this.$t("provider"), value: "provider" },
        ];
      } else {
        // Opções do Select utilizados para o Cassino antigo
        return [
          { text: this.$t("games"), value: "jogo" },
          { text: this.$t("gameType"), value: "tipo" },
          { text: this.$t("provider"), value: "provedor" },
        ];
      }
    },
    isNewCasinoPage() {
      return (
        this.$route.name == "CasinoListBetOnline" ||
        this.$route.name === "CollaboratorCasinoListBetOnline"
      );
    },
  },
  watch: {
    $route() {
      this.reset();
    },
  },
  methods: {
    setSelectedGroup(value) {
      this.$store.commit("setSelectCasinoGroupBy", value);
    },
    reset() {
      // Reset values in others views using this Select
      let valueByPage = this.isNewCasinoPage ? "game" : "jogo";
      this.selectedGroup = { text: this.$t("games"), value: valueByPage };
      this.$store.commit("setSelectCasinoGroupBy", valueByPage);
    },
  },
};
</script>
